import styled from "styled-components";
import { t } from "./theme";
import { UI_BODY_SEMIBOLD_SM_DF } from "oolib";
import { motion } from "framer-motion";

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 10px;
    background: ${t("surface0")};
    position: sticky;
    top: 0;
    z-index: 10;
    border-bottom: 1px solid ${t("grey10")};
`;

export const HeaderTitleContainer = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    /* take the space the actions don't need, and let the title truncate inside
       it rather than pushing the header wider */
    flex: 1 1 auto;
    min-width: 0;
`;

export const HeaderInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1 auto;
    min-width: 0;
`;

export const HeaderSubtitle = styled(UI_BODY_SEMIBOLD_SM_DF)`
    display: flex;
    gap: 8px;
    color: ${t("grey50")};
`;

export const HeaderActionsContainer = styled.div`
    display: flex;
    /* content-height (don't stretch to the full header height) + center, so the
       save status lines up with the action buttons rather than the bar middle */
    align-self: flex-start;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
`;

export const ContentGrid = styled(motion.div)`
    display: grid;
    gap: 14px;
    padding: 14px;
    background: ${t("surfaceMinus1")};
    flex: 1;
`;

export const ContentGrid2 = styled.div`
    display: grid;
    /* minmax(0, …) instead of bare fr: an fr track's implicit min is auto, which
       lets non-wrapping content (e.g. a long filter label) blow the track past
       its share. minmax(0, …) lets tracks shrink so content truncates instead. */
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
    gap: 6px;
    align-items: start;
    margin-inline: auto;
    width: 100%;

    /* Round outer corners of the first/last card in each edge column,
       so the grid reads as a single rounded panel regardless of card count. */
    > :first-child > :first-child { border-top-left-radius: 16px; }
    > :first-child > :last-child { border-bottom-left-radius: 16px; }
    > :last-child > :first-child { border-top-right-radius: 16px; }
    > :last-child > :last-child { border-bottom-right-radius: 16px; }
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const Card = styled.div`
    background: ${t("surface1")};
    border-radius: 6px;
    border: 1px solid ${t("grey10")};
    padding: 16px;
`;

export const Panel = styled(motion.div)`
    background: radial-gradient(175.64% 76.91% at 16.48% 2.13%, ${t("surface1")} 0%, ${t("surfaceMinus1")} 100%);
    border-radius: 16px;
    border: 1px solid ${t("grey10")};
    min-width: 48px;
    min-height: 48px;
    position: relative;
    overflow: hidden;
`;

export const IconContainer = styled(motion.div)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
`;